jQuery(document).ready(function() {  

	if ( jQuery( ".content-pint" ).length ) {
        var $grid = jQuery('.content-pint').masonry({
          columnWidth: '.element',
          gutter:20,
          isFitWidth: true
        });
        // layout Isotope after each image loads
        $grid.imagesLoaded().progress( function() { $grid.masonry(); } );
    }

});